import React, { useState } from "react";
import { motion } from "framer-motion";
import heroImg from "../assets/6236838.jpg";
import ConsultationModal from "./ConsultationModal";

function Hero() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <section id="home" className="hero">
        <div className="hero-container">

          {/* LEFT */}
          <div className="hero-left">
            <motion.span
              className="hero-badge"
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              Digital Growth Agency
            </motion.span>

            <motion.h1
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              Growth Marketing Agency for Startups &amp; Enterprises
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              Driving lead generation, business development, ROI-focused marketing,
              and strong brand promotion &amp; visibility.
            </motion.p>
          </div>

          {/* RIGHT */}
          <div className="hero-right">
            <div className="circle-bg" />
            <motion.img
              src={heroImg}
              alt="marketing professional"
              className="hero-img"
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.15 }}
            />
            <div className="pulse-dot pulse-1" />
            <div className="pulse-dot pulse-2" />
          </div>

        </div>
      </section>

      <ConsultationModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </>
  );
}

export default Hero;
